import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective, TranslocoModule, TranslocoPipe } from '@jsverse/transloco';
import { TranslocoService } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [RouterLink, TranslocoModule, TranslocoDirective, CommonModule],
  templateUrl: './privacy-policy.html',
  styleUrl: '../../../styles.css',
})
export class PrivacyPolicyComponent {
  constructor(
    private readonly translocoService: TranslocoService
  ) {}
  
  changelanguage(lang: string) {
    this.translocoService.setActiveLang(lang);
  }
}
